export const getCdnUrl = (url) => {
    return `${process.env.REACT_APP_IMAGES_URL}${url}`
}
